import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnDebtorsSalesPerson } from '@utils/columns'
import Layout from '@components/Layout'
import { useNavigate } from 'react-router-dom'
import { debouncedSet } from '@utils/debounce'
import { useQuery } from '@tanstack/react-query'
import { fetchSalesPersonKPI } from '@utils/fetchData'
import { getToday } from '@utils/time'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import SalesPersonKPIBySlp from '@components/Modal/SalesPersonKPIModal'
import { useSelector } from 'react-redux'
import { downloadExcel } from '@utils/downloadPdf'
import moment from 'moment'
import { Input } from 'antd'
import ViewIcon from '@assets/icons/viewSvg'

const SalesPersonKPI = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const formattedDate = moment().startOf('month').format('YYYY-MM-DD')

	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState(formattedDate)
	const [endDate, setEndDate] = useState(formattedDate)
	const [pageSize] = useState(100)
	const [page, setPage] = useState(0)
	const [loadingExcel, setLoadingExcel] = useState(false)
	const [month, setMonth] = useState(moment().format('YYYY-MM'))

	const handleChange = (e) => {
		setMonth(e.target.value)
	}
	const [viewModalOpen, setViewModalOpen] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const { data = [], isLoading } = useQuery({
		queryKey: ['salesPersonKPI', `${month}-01`],
		queryFn: fetchSalesPersonKPI,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleViewClick = (record) => {
		setSelectedRowData(record)
		setViewModalOpen(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-debt-by-managers',
			params: {
				startDate,
				endDate,
				pageSize: 1000,
				pageToken: 0,
			},
			fileName: "Qazrdorlar menejerlar bo'yicha",
			onLoadingChange: setLoadingExcel,
		})
	}

	const getMonthKeys = (data) => {
		if (!data?.length) return []

		return Object.keys(data[0])
			.filter((key) => key.startsWith('month'))
			.sort((a, b) => {
				const aNum = Number(a.replace('month', ''))
				const bNum = Number(b.replace('month', ''))
				return aNum - bNum
			})
	}
	const monthKeys = getMonthKeys(data)

	const monthColumns = monthKeys.map((monthKey) => {
		const index = monthKey.replace('month', '')
		const paidKey = `paidMonth${index}`

		return {
			title: data?.[0]?.[monthKey] ?? '-', // ✅ SAFE
			key: monthKey,
			align: 'right',
			render: (_, record) => {
				return (
					<span>
						{new Intl.NumberFormat('fr-FR').format(
							record[paidKey] || 0,
						)}
					</span>
				)
			},
		}
	})

	// Step 2: Base columns (fixed)
	const baseColumns = [
		{
			title: t('slpName'),
			dataIndex: 'slpName',
			key: 'slpName',
			width: 170,
		},
		{
			title: t('salesCurrentMonth'),
			dataIndex: 'salesCurrentMonth',
			key: 'salesCurrentMonth',
			render: (value) =>
				new Intl.NumberFormat('fr-FR', {
					minimumFractionDigits: 2,
				}).format(value || 0),
			width: 200,
		},
		{
			title: t('paymentsForCurrentMonthSales'),
			dataIndex: 'paymentsForCurrentMonthSales',
			key: 'paymentsForCurrentMonthSales',
			render: (value) =>
				new Intl.NumberFormat('fr-FR').format(value || 0),
			width: 150,
		},
	]

	const columns = [
		...baseColumns,
		...monthColumns,

		{
			title: '',
			key: 'action',
			align: 'center',
			width: 80,
			render: (_, record) => (
				<button
					onClick={() => handleViewClick(record)}
					className="bg-[#2198c7] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
				>
					<ViewIcon />
				</button>
			),
		},
	]

	return (
		<Layout>
			<Header
				title={'salesPersonKPI'}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				scrollX={1500}
				renderFilters={true}
				renderFiltersInBottom={() => {
					return (
						<div className="flex flex-col gap-3">
							<span>{t('month')}</span>

							<Input
								type="month"
								value={month}
								onChange={handleChange}
								className="w-[200px]"
							/>
						</div>
					)
				}}
				// onStartDateChange={handleStartDate}
				// onEndDateChange={handleEndDate}
				// startDate={startDate}
				// endDate={endDate}
				// formattedDate={formattedDate}
				// isShowExcelBtn
				// handleDownloadExcel={handleDownloadExcel}
				// loadingExcel={loadingExcel}
			/>
			<SalesPersonKPIBySlp
				visible={viewModalOpen}
				onClose={() => setViewModalOpen(false)}
				data={selectedRowData}
			/>
		</Layout>
	)
}

export default SalesPersonKPI
